// document.addEventListener("DOMContentLoaded", function () {

//   gsap.registerPlugin(ScrollTrigger);

//   const quotes = document.querySelectorAll("blockquote.is-style-fancy-quote p");

//   quotes.forEach((quote) => {

//     const originalText = quote.textContent; // safer than innerHTML
//     const textLength = originalText.length;
//     const divHeight = quote.scrollHeight + 200;

//     ScrollTrigger.create({
//       trigger: quote,
//       pin: true,
//       start: "center center",
//       end: "+=" + divHeight,
//       scrub: 0.1,
//       markers: false,
//       onUpdate: (self) => {
//         updateQuoteColors(
//           textLength * self.progress,
//           quote,
//           originalText
//         );
//       }
//     });

//   });

//   function updateQuoteColors(point, quoteElement, originalText) {
//     if (point < 0) return;

//     let newText = "";

//     for (let i = 0; i < originalText.length; i++) {

//       if (i < point) {
//         newText += `<span class="color1">${originalText[i]}</span>`;
//       } 
//       else if (i >= point && i <= point + 10) {
//         newText += `<span class="color2">${originalText[i]}</span>`;
//       } 
//       else {
//         newText += `<span class="color3">${originalText[i]}</span>`;
//       }

//     }

//     quoteElement.innerHTML = newText;
//   }

// });


// removing animation for large screens

document.addEventListener("DOMContentLoaded", function () {

  gsap.registerPlugin(ScrollTrigger);

  const quotes = document.querySelectorAll("blockquote.is-style-fancy-quote p");

  /* =========================
     RESPONSIVE HANDLING
  ========================= */
  ScrollTrigger.matchMedia({

    /* =========================
       NORMAL SCREENS (ANIMATION ON)
    ========================= */
    "(max-height: 900px)": function () {

      quotes.forEach((quote) => {

        const originalText = quote.textContent;
        const textLength = originalText.length;
        const divHeight = quote.scrollHeight + 200;

        ScrollTrigger.create({
          trigger: quote,
          pin: true,
          start: "center center",
          end: "+=" + divHeight,
          scrub: 0.1,
          markers: false,
          onUpdate: (self) => {
            updateQuoteColors(
              textLength * self.progress,
              quote,
              originalText
            );
          }
        });

      });

    },

    /* =========================
       LARGE SCREENS (NO ANIMATION → FINAL STATE)
    ========================= */
    "(min-height: 901px)": function () {

      quotes.forEach((quote) => {

        const originalText = quote.textContent;

        // 👉 Direct final state (fully highlighted)
        quote.innerHTML = `<span class="color1">${originalText}</span>`;

      });

    }

  });


  /* =========================
     TEXT COLOR TRANSITION
  ========================= */
  function updateQuoteColors(point, quoteElement, originalText) {

    if (point < 0) return;

    let newText = "";

    for (let i = 0; i < originalText.length; i++) {

      if (i < point) {
        newText += `<span class="color1">${originalText[i]}</span>`;
      } 
      else if (i >= point && i <= point + 10) {
        newText += `<span class="color2">${originalText[i]}</span>`;
      } 
      else {
        newText += `<span class="color3">${originalText[i]}</span>`;
      }

    }

    quoteElement.innerHTML = newText;
  }

});